export const BACKEND_KEY = 'Pensions';
export const BASE_PENSION = {};
export const HAS_LUMP_SUM = 1;
export const HAS_MONTHLY_PAYMENT = 2;
export const JOINT_SURVIVOR = 1;
export const LUMP_SUM = 2;

export const PENSIONS_CRUD_OVERVIEW = 0;
export const PENSIONS_CRUD_ADD_EDIT = 1;
